const DashboardFormResources = {

    form_data:{
        view_by: 2,
        associate_id: [],
        room_type_id: [],
        date_range: {},
        date_option_selected: ''
    },

    form_data_discharges:{
        daily_assignment_id: [],
        shift_id: [],
        shift_class_id: [],
        view_by: 2,
        from_mobile_app: 3,
        list_shift_types: false,
        date_1: '',
        date_2: ''
    },

    form_data_rooms_cleaned:{
        room_type_id: [],
        essential_cleaning: '',
        date_range: {startDate: '', endDate: ''},
        from_mobile_app: 3,
        date_option_selected: ''
    },

    form_data_log_productivity:{
        daily_assignment_id: [],
        shift_id: [],
        shift_class_id: [],
        cost_center_department_id: [],
        date_range: {startDate: '', endDate: ''},
        view_by: 2,
        from_mobile_app: 3,
        list_shift_types: false,
        date_option_selected: ''
    },

    form_format:[
        {
            css_class:  'col-md-3 col-sm-12 pr-3',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Supervisor:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select supervisor(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-3 col-sm-12 pr-3',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Room Type:',
            model_name: 'room_type_id',
            ref:        'room_type_id_input',
            ref_alt:    'room_type_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select room type(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-3 col-sm-12 pr-3',
            type:       'date-picker',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Date Range:',
            model_name: 'date_range',
            ref:        'date_range_input',
            ref_alt:    'date_range_input_alt',
            required:   false,
        },
    ],

    form_format_discharges:[
        {
            css_class:  'col-md-4 col-sm-12 pr-3',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Daily Assignment:',
            model_name: 'daily_assignment_id',
            ref:        'daily_assignment_id_input',
            ref_alt:    'daily_assignment_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select daily assignments(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-4 col-sm-12 pr-3',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'List Shift Types:',
            model_name: 'list_shift_types',
            ref:        'list_shift_types_input',
            ref_alt:    'list_shift_types_input_alt',
            required:   false,
            style: 'visibility: hidden;'
        },
    ],

    form_format_rooms_cleaned:[
        {
            css_class:  'col-md-4 col-sm-12 pr-3',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Essential Cleaning:',
            model_name: 'essential_cleaning',
            ref:        'essential_cleaning_input',
            ref_alt:    'essential_cleaning_input_alt',
            required:   false,
            search: false,
        },
        {
            css_class:  'col-md-4 col-sm-12 pr-3',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Room Type:',
            model_name: 'room_type_id',
            ref:        'room_type_id_input',
            ref_alt:    'room_type_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select room type(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-4 col-sm-12 pr-3',
            type:       'date-picker',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Date Range:',
            model_name: 'date_range',
            ref:        'date_range_input',
            ref_alt:    'date_range_input_alt',
            required:   false,
        },
    ],

    form_format_log_productivity:[
        {
            css_class:  'col-md-4 col-sm-12 pr-3 pl-0',
            type:       'date-picker',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Date Range:',
            model_name: 'date_range',
            ref:        'date_range_input',
            ref_alt:    'date_range_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4 col-sm-12 pr-3 pl-0',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Daily Assignment:',
            model_name: 'daily_assignment_id',
            ref:        'daily_assignment_id_input',
            ref_alt:    'daily_assignment_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select assignments(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-4 col-sm-12 pl-0',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Department:',
            model_name: 'cost_center_department_id',
            ref:        'cost_center_department_id_input',
            ref_alt:    'cost_center_department_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select department(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-4 col-sm-12 pr-3 pl-0',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Shift:',
            model_name: 'shift_id',
            ref:        'shift_id_input',
            ref_alt:    'shift_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select shift(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-4 col-sm-12 pr-3',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'List Shift Types:',
            model_name: 'list_shift_types',
            ref:        'list_shift_types_input',
            ref_alt:    'list_shift_types_input_alt',
            required:   false,
        },
    ],
}

export default DashboardFormResources;